module.exports = __webpack_public_path__ + "static/P1-Kingstorn-b9aa936f26a2779d6a840e12464c2bb7.jpeg";